export default __webpack_public_path__ + "static/media/gc-gray-white@2x.23693d2d.png";